import React from 'react'
import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import './actionButtons.css'

import { FileText, Trash } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from "react-router-dom"
import { handleCleanForm, handleStartEditing } from '../../../redux/actions/form'
import { startDeleteRegister } from '../../../redux/actions/list'
import { serverRequest } from '../../../utility/helpers/Axios/serverRequest'
import { handleGenericSwal } from '../../../utility/helpers/Swal/handleGenericSwal'
import { useRedirect } from '../../../utility/hooks/useRedirect'


export const ActionButtons = ({ isForm = true, onSubmit, onCancel = null, endPoint, styles = {}, extraOptions = [] }) => {
    const { id } = useParams()
    const { form } = useSelector(state => state)
    const { edited, store } = form

    const dispatch = useDispatch()
    const redirect = useRedirect(id)

    const pathname = useLocation().pathname
    const isAdd = pathname.slice(-3) === 'add'

    const handleGoBack = () => {
        dispatch(handleCleanForm())
        redirect.redirectToList()
    }
    const cancelButtonClick = !!onCancel ? onCancel : handleGoBack

    const handleStore = async () => {
        const { confirm } = await handleGenericSwal({
            title: '¿Estás seguro que quieres archivar/desarchivar el registro?',
            text: ' ',
            configuration: { confirmButtonText: 'Confirmar' },
            confirm: {
                title: '¡Aplicando cambios!',
                text: 'Estamos aplicando los cambios en el registro'
            }
        })

        if (confirm) {
            await serverRequest(endPoint, id, { ...form, store: !store }, 'PUT')
            if (id) dispatch(handleStartEditing(endPoint, id))
        }
    }

    const handleDelete = () => dispatch(startDeleteRegister(id, endPoint, cancelButtonClick))


    return (
        <div id="actionButtons" className="d-flex">
            {isForm ? (
                <>
                    {((!isAdd && !edited) || extraOptions.length) ? (
                        <UncontrolledDropdown>
                            <DropdownToggle className='pr-1' tag='span'>
                                <Button.Ripple className="float-back mx-25" color='secondary' style={{ marginRight: '10px', ...styles }}>
                                    <span className='align-middle'>Opciones</span>
                                </Button.Ripple>
                            </DropdownToggle>
                            <DropdownMenu right>
                                {(!isAdd && !edited) && (
                                    <>
                                        {/* <DropdownItem tag='a' className='w-100' onClick={handleStore}>
                                            <FileText size={15} />
                                            <span className='align-middle ml-50'>{store ? 'Desarchivar' : 'Archivar'}</span>
                                        </DropdownItem> */}
                                        <DropdownItem tag='a' className='w-100' onClick={handleDelete}>
                                            <Trash size={15} />
                                            <span className='align-middle ml-50'>Eliminar</span>
                                        </DropdownItem>
                                    </>
                                )}
                                {
                                    extraOptions.map(({ OptionComponent, ...o }, i) => !!OptionComponent
                                        ? <OptionComponent key={`customOptionComponent_${i}`} {...o} />
                                        : (
                                            <DropdownItem key={`customOption_${i}`} tag='a' className='w-100' onClick={() => handleOption(o.function, o)}>
                                                <o.icon size={12} />
                                                <span className='align-middle ml-50'>{o.name}</span>
                                            </DropdownItem>
                                        )
                                    )
                                }
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    ) : null}

                    <Button.Ripple className="float-back mx-25" color='secondary' outline style={{ marginRight: '10px', ...styles }} onClick={() => cancelButtonClick()}>
                        <span className='align-middle'>{edited ? 'Cancelar' : 'Atrás'}</span>
                    </Button.Ripple>
                    <Button.Ripple className="float-save mx-25" color='primary' style={{ ...styles }} onClick={(e) => onSubmit(e)}>
                        <span className='align-middle'>Guardar</span>
                    </Button.Ripple>
                </>
            ) : (
                <>
                    <Button.Ripple className="float-save mx-25" color='secondary' outline onClick={() => { handleGoBack() }}>
                        <span className='align-middle'>Atrás</span>
                    </Button.Ripple>
                </>
            )}
        </div>
    )
}

